/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Row, Col, Form, message, Select, Spin, Upload, Button } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

import uploadLogo from "../../../assests/images/bx_upload.svg";
import API from "../../../api";
import urls from "../../../api/urls";

const { LEAD_CP_UPLOAD, UPDATE_LEAD_CP_DETAILS } = urls;
import useCustomNavigate from "../../../components/customNavigationHook";
import { customerOnboardingAPI } from "../../../api/LeadApi";
import {
  validateClientOrgDetails,
  validateBusinessDetails,
} from "../AggreementDetails/validateFields";

export const DocumentDetails = ({
  getData,
  goBackStep = () => {},
  userType,
  goToStep = () => {},
  btnName = "SAVE & CONTINUE",
}) => {
  const navigate = useCustomNavigate();
  const { Dragger } = Upload;
  const userId = JSON.parse(localStorage.getItem("userId"));
  const [form] = Form.useForm();
  const [fileList, setfileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userinfo"));
  const [documentFields, setDocumentFields] = useState([
    { id: 0, docType: "", files: [] },
  ]);

  useEffect(() => {
    let data = getData?.documents?.filter((item) => item?.type === "BRANDING");
    if (data?.length > 0) {
      setDocumentFields(
        data?.map((item, i) => ({
          id: i,
          docType: item?.docType,
          files: item?.fileLocationUrl
            ? [
                {
                  url: item?.fileLocationUrl,
                  response: item?.fileLocationUrl,
                  name: item?.fileLocationUrl?.split("/").pop(),
                  uid: i,
                },
              ]
            : [],
        }))
      );

      // Prepare field values for form
      const fieldValues = data.reduce((acc, item, i) => {
        acc[`documentName_${i}`] = item?.docType;
        acc[`documentUrl_${i}`] = item?.fileLocationUrl
          ? [
              {
                uid: i,
                url: item?.fileLocationUrl,
                name: item?.fileLocationUrl?.split("/").pop(),
                response: item?.fileLocationUrl,
              },
            ]
          : [];
        return acc;
      }, {});

      // Set form values after ensuring form is initialized
      form.setFieldsValue(fieldValues);
    }
  }, [getData, form]);

  const docTypes = ["Inside Office", "Front Side", "Distant front/CCTV"];

  const handlePreview = async (file) => {
    window.open(file?.response);
  };

  const fileProps = {
    name: "files",
    multiple: true,
    listType: "picture",
    showUploadList: true,
    action: `${LEAD_CP_UPLOAD + "document"}`,
    className: "upload-list-inline",

    fileList:
      Array.isArray(fileList) &&
      fileList.length > 0 &&
      typeof fileList[0] === "object"
        ? fileList
        : fileList?.length
        ? fileList?.map((val) => {
            return { name: val?.split("/").pop(), response: val };
          })
        : null,
  };

  const addDocumentField = () => {
    setDocumentFields([
      ...documentFields,
      {
        id: documentFields.length,
        docType: "",
        files: [],
      },
    ]);
  };

  const removeDocumentField = (fieldId) => {
    setDocumentFields(documentFields.filter((field) => field.id !== fieldId));
  };
  const handleChange =
    (fieldId) =>
    ({ fileList: newFileList, file }) => {
      const updatedFields = documentFields.map((field) => {
        if (field.id === fieldId) {
          return { ...field, files: newFileList };
        }
        return field;
      });
      setDocumentFields(updatedFields);
    };

  function handleRemoveFile(params) {
    message.success("File removed successfully");
    // setfileList([]);
  }

  const beforeUpload = (file, onSuccess) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (file) {
      let checkSameFile = fileList
        ?.map((val) => val?.name)
        .some((val) => val === file?.name);

      if (file?.name?.includes("jfif")) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      if (checkSameFile) {
        message.error("Same file cannot be uploaded again");
        return Upload.LIST_IGNORE;
      }
      if (!isLt2M) {
        message.error("File size should be less than 10MB");
        return Upload.LIST_IGNORE;
      }
      if (!isJpgOrPng) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      return isJpgOrPng && isLt2M;
    } else {
      if (onSuccess) {
        message.success("File uploaded");
      }
      onSuccess("ok");
      return true;
    }
  };

  const headers = {
    Authorization: "Bearer " + userData?.accessToken,
    "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
    "USER-ID": userId?.userInfo?.userId,
  };

  const saveDocDetails = async (val) => {
    let payload = Object.keys(val)
      .filter((key) => key.startsWith("documentName_"))
      .map((key) => {
        let index = key.split("_")[1];
        return {
          docType: val[key],
          fileLocationUrl:
            val[`documentUrl_${index}`]?.fileList?.[0]?.response ||
            documentFields[index]?.files[0]?.url,
          type: "BRANDING",
        };
      });
    setLoading(true);
    let user =
      {
        CLIENT: "clientLeadId",
        COMPANY: "customerIdCompany",
      }[userType] || "customerId";
    const id = localStorage.getItem(user) || getData?.customerId;
    if (userType === "CLIENT") {
      if (validateClientOrgDetails(getData)) {
        message.error("Fill all the required fields");
        goToStep(0);
        return;
      }
      if (validateBusinessDetails(getData)) {
        message.error("Fill all the required fields");
        goToStep(3);
        return;
      }
    }

    let response = await customerOnboardingAPI.patchLead(id, {
      documents: payload,
    });

    if (response?.status) {
      setLoading(false);
      message.success("Documents added successfully.");
      reRoute();
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message);
    }
  };

  const reRoute = () => {
    let url =
      {
        CLIENT: "/client-lead-generation-list",
        COMPANY: "/profile",
        CP: "/cp-lead-generation-list",
      }[userType] || "/profile";

    const options = userType === "COMPANY" ? { state: { tab: "3" } } : {};

    navigate(url, options);
  };

  const setDocType = (val, index) => {
    const updatedFields = documentFields.map((field, i) => {
      if (i === index) {
        return { ...field, docType: val };
      }
      return field;
    });
    setDocumentFields(updatedFields);
  };

  return (
    <Spin spinning={loading}>
      <Form
        id="myForm"
        className="global-form profile-container-form p-2"
        layout="vertical"
        form={form}
        scrollToFirstError={{
          behavior: "smooth",
          block: "center",
          inline: "center",
        }}
        onFinish={saveDocDetails}
      >
        {documentFields.map((field, index) => (
          <Row gutter={10} className="global-form-row" key={field.id}>
            <Col span={11}>
              <Form.Item
                name={`documentName_${field.id}`}
                label="Select Doc"
                rules={[{ required: true, message: "Please select doc type" }]}
              >
                <Select
                  placeholder="Select Doc Type"
                  options={docTypes.map((item) => ({
                    label: item,
                    value: item,
                    disabled: documentFields?.some(
                      (val) => val?.docType === item
                    ),
                  }))}
                  //disabled={getData?.status?.toLowerCase() === "approved"}
                  onChange={(val) => setDocType(val, index)}
                />
              </Form.Item>
            </Col>

            <Col span={11}>
              <Form.Item
                name={`documentUrl_${field.id}`}
                label="Upload file"
                rules={[{ required: true, message: "Please upload a file" }]}
              >
                <Dragger
                  {...fileProps}
                  className="dragger-doc"
                  onChange={handleChange(field.id)}
                  onRemove={handleRemoveFile}
                  maxCount={1}
                  onPreview={handlePreview}
                  beforeUpload={beforeUpload}
                  multiple={false}
                  headers={headers}
                  fileList={field.files}
                  // disabled={
                  //   getData?.status?.toLowerCase() === "approved" ||
                  //   !form.getFieldValue(`documentName_${field.id}`)
                  // }
                >
                  <Row>
                    <Col
                      span={3}
                      //className="m-auto"
                      style={{ borderRight: "1px solid #CECECE" }}
                    >
                      <img
                        src={uploadLogo}
                        className="Upload-logo"
                        style={{ width: "30px", height: "30px" }}
                      />
                    </Col>
                    <Col span={21} className="f-13">
                      <p>
                        Click to upload or drag and drop. Supported file type:
                        PDF, JPEG, PNG
                      </p>
                      {/* <p>Maximum file size 10 MB</p> */}
                    </Col>
                  </Row>
                </Dragger>
              </Form.Item>
            </Col>
            <Col span={2}>
              {documentFields.length > 1 && (
                <Button
                  type="link"
                  danger
                  onClick={() => removeDocumentField(field.id)}
                  icon={<DeleteOutlined />}
                />
              )}
            </Col>
          </Row>
        ))}

        <Row className="center mt-1">
          <Col span={12}>
            <Button
              type="dashed"
              onClick={addDocumentField}
              block
              icon={<PlusOutlined />}
              //disabled={getData?.status?.toLowerCase() === "approved"}
            >
              Add Another Branding
            </Button>
          </Col>
        </Row>
        <div className="flex-end m-1">
          <Button className="cancel-btn ml-1 w-15" onClick={goBackStep}>
            BACK
          </Button>
          <Button
            htmlType="submit"
            className="save-btn  ml-1"
            id="saveNContinue"
          >
            {btnName}
          </Button>

          {/* {getData?.status?.toLowerCase() !== "approved" ? (
            <Button
              htmlType="submit"
              className="save-btn  ml-1"
              id="saveNContinue"
            >
              {btnName}
            </Button>
          ) : (
            <Button
              id="saveNContinue"
              onClick={() => reRoute()}
              className="save-btn  ml-1"
            >
              NEXT
            </Button>
          )} */}
        </div>
      </Form>
    </Spin>
  );
};

export default DocumentDetails;
